import React from "react";
import { Helmet } from "react-helmet-async";
import LegalPageLayout from "./shared/LegalPageLayout";

const Terms = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms of Service - The Wart Guy</title>
        <meta
          name="description"
          content="Terms of Service for The Wart Guy - Read our terms and conditions for using our platform."
        />
      </Helmet>

      <LegalPageLayout
        title="Terms of Service"
        subtitle={`Last Updated ${new Date().toLocaleDateString()}`}
      >
        <p>
          Welcome to The Wart Guy. These Terms of Use govern your access to and
          use of our website at thewartguy.com ("Website"). By accessing or
          using the Website, you agree to be bound by these Terms of Use. If you
          do not agree with any part of these terms, please do not use our
          Website.
        </p>

        <h2>1. About The Wart Guy</h2>
        <p>
          The Wart Guy is a platform dedicated to providing information and
          resources about plantar wart treatments. Our mission is to share
          personal experiences, research, and treatment options for individuals
          suffering from plantar warts.
        </p>

        <h2>2. Content and Information</h2>
        <ul>
          <li>
            <strong>Informational Purpose Only:</strong> The content on this
            Website is provided for general informational purposes only. It is
            not intended to be a substitute for professional medical advice,
            diagnosis, or treatment. Always seek the advice of your physician or
            other qualified health provider with any questions you may have
            regarding a medical condition.
          </li>
          <li>
            <strong>User Responsibility:</strong> You are responsible for
            evaluating the information available on the Website. We are not
            responsible for any health decisions you make based on the
            information provided.
          </li>
          <li>
            <strong>No Guarantee:</strong> We do not guarantee the accuracy,
            completeness, or usefulness of any information on the Website, and
            neither we nor our content providers shall be responsible or liable
            for any errors, omissions, or inaccuracies.
          </li>
        </ul>

        <h2>3. User Conduct</h2>
        <p>When using the Website, you agree not to:</p>
        <ul>
          <li>
            Use the Website in any way that violates any applicable federal,
            state, local, or international law or regulation.
          </li>
          <li>
            Attempt to interfere with, compromise the system integrity or
            security, or decipher any transmissions to or from the servers
            running the Website.
          </li>
          <li>Collect or track the personal information of others.</li>
          <li>
            Impersonate or attempt to impersonate The Wart Guy, a Wart Guy
            employee, another user, or any other person or entity.
          </li>
          <li>
            Engage in any other conduct that restricts or inhibits anyone's use
            or enjoyment of the Website, or which, as determined by us, may harm
            The Wart Guy or users of the Website or expose them to liability.
          </li>
        </ul>

        <h2>4. Disclaimers and Limitations of Liability</h2>
        <ul>
          <li>
            <strong>No Medical Advice:</strong> The Wart Guy provides general
            information about plantar wart treatments and personal experiences
            from other users. The content on the Website is not intended to be
            medical advice and should not be relied upon as a substitute for
            professional medical consultation. Always seek the advice of your
            physician or another qualified healthcare provider with any
            questions you may have regarding a medical condition.
          </li>
          <li>
            <strong>No Guarantees:</strong> The Wart Guy does not guarantee the
            accuracy, completeness, or usefulness of any content posted on the
            Website. Any reliance you place on such information is at your own
            risk.
          </li>
          <li>
            <strong>Limitation of Liability:</strong> In no event shall The Wart
            Guy or its affiliates be liable for any damages arising out of your
            use of the Website or reliance on the information provided, even if
            we have been advised of the possibility of such damages.
          </li>
        </ul>

        <h2>5. Privacy and Data Collection</h2>
        <p>
          Your use of The Wart Guy is subject to our Privacy Policy. By using
          the Website, you consent to the collection and use of your information
          as described in the Privacy Policy.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          The Website may contain links to third-party websites or services that
          are not owned or controlled by The Wart Guy. We have no control over,
          and assume no responsibility for, the content, privacy policies, or
          practices of any third-party websites or services. You further
          acknowledge and agree that The Wart Guy shall not be responsible or
          liable, directly or indirectly, for any damage or loss caused or
          alleged to be caused by or in connection with the use of or reliance
          on any such content, goods, or services available on or through any
          such websites or services.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          The Website and its original content, features, and functionality are
          and will remain the exclusive property of The Wart Guy and its
          licensors. The Website is protected by copyright, trademark, and other
          laws of both the United States and foreign countries. Our trademarks
          and trade dress may not be used in connection with any product or
          service without the prior written consent of The Wart Guy.
        </p>

        <h2>8. Changes to Terms of Use</h2>
        <p>
          We may revise and update these Terms of Use from time to time at our
          sole discretion. All changes are effective immediately when we post
          them and apply to all access to and use of the Website thereafter.
          Your continued use of the Website following the posting of revised
          Terms of Use means that you accept and agree to the changes.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          These Terms of Use shall be governed by and construed in accordance
          with the laws of the United States of America, without regard to its
          conflict of law principles. Any dispute arising under these Terms of
          Use shall be resolved exclusively in the courts located in the United
          States of America.
        </p>

        <h2>10. Contact Information</h2>
        <p>
          If you have any questions or concerns about these Terms of Use, please
          contact us at:
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:info@thewartguy.com">info@thewartguy.com</a>
        </p>
      </LegalPageLayout>
    </>
  );
};

export default Terms;
